"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_select_1 = require("react-select");
var MultiSelect = /** @class */ (function (_super) {
    __extends(MultiSelect, _super);
    function MultiSelect(props) {
        var _this = _super.call(this, props) || this;
        _this.onChange = function (value, _a) {
            var action = _a.action, removedValue = _a.removedValue;
            switch (action) {
                case 'remove-value':
                case 'pop-value':
                    if (removedValue.isFixed) {
                        return;
                    }
                    break;
                case 'clear':
                    value = _this.props.options.filter(function (v) { return v.isFixed; });
                    break;
            }
            _this.setState({ value: value }, function () { return _this.props.onChange(value); });
        };
        _this.state = {
            value: props.initialValue,
            customStyles: __assign({
                multiValueLabel: function (provided, state) {
                    var newStyle = provided;
                    if (state.data.isDisabled) {
                        newStyle = __assign(__assign({}, provided), { paddingRight: "6px" });
                    }
                    return newStyle;
                },
                multiValueRemove: function (provided, state) {
                    var newStyle = provided;
                    if (state.data.isDisabled) {
                        newStyle = __assign(__assign({}, provided), { display: "none" });
                    }
                    return newStyle;
                },
            }, props.styles)
        };
        return _this;
    }
    MultiSelect.prototype.render = function () {
        return (React.createElement(react_select_1.default, { styles: this.state.customStyles, isMulti: true, options: this.props.options, isClearable: this.state.value.some(function (v) { return !v.isFixed; }), onChange: this.onChange, value: this.state.value }));
    };
    return MultiSelect;
}(React.Component));
exports.MultiSelect = MultiSelect;
//# sourceMappingURL=MultiSelect.js.map